import React from "react";
import { Section } from "components/section";
import { SplitsAnimation } from "components/animations";
import { Diptych, DiptychColumn } from "ui/diptych";
import { TextTitle } from "ui/text";
import { Box } from "@chakra-ui/react";
import { DecorativeBackgroundImage } from "components/images";
import performanceBg from "../../../../public/assets/platform/campaign-intelligence/performance-bg.png";
import { AnalyzeFunnelsAnimation, BreakdownsAnimation } from "./animations";

export function CampaignIntelligenceFeatures() {
  return (
    <Section>
      <TextTitle
        align="center"
        size="lg"
        maxW="840px"
        descriptionMaxW="600px"
        chip={{ text: "Campaign Intelligence features" }}
        title="You can do more when intelligence is built into your CDP"
        description="You build audiences for campaigns in your CDP. You should be able to explore complete customer profiles and analyze campaign results in it, too."
      />

      <DiptychColumn mt={{ base: "biggest", md: "huge" }}>
        <Diptych
          direction="left"
          size="lg"
          chip={{ text: "Performance" }}
          title="Measure trends over time"
          description="Define and track all metrics across any audience, campaign, or A/B test to understand how your marketing activities are driving growth for your business."
          media={
            <Box
              boxSize="100%"
              p={{ base: "smallest", lg: "small" }}
              pb={{ base: "bigger", lg: "biggest", xl: "huge" }}
              pos="relative"
            >
              <DecorativeBackgroundImage src={performanceBg} />
              <SplitsAnimation
                maxW={{ base: "80%", lg: "90%", xl: "540px" }}
                mt={{ base: "tiny", lg: "smaller", xl: "big" }}
                mr={{ base: "tiny", lg: "small", xl: "big" }}
                keyContainerProps={{ top: { base: 0, lg: -4, xl: -2 }, right: { base: -4, xl: -10 } }}
              />
            </Box>
          }
        />

        <Diptych
          direction="right"
          size="lg"
          chip={{ text: "Breakdowns" }}
          title="Slice data by any attribute"
          description="Drill down into events, audiences, and metrics by any attribute to uncover new learnings from your full data."
          media={<BreakdownsAnimation />}
        />

        <Diptych
          direction="left"
          size="lg"
          chip={{ text: "Funnels" }}
          title="Analyze customer journeys"
          description="Build custom funnels to discover unique patterns in your customer journeys to understand cross-channel behavior and find new growth opportunities."
          media={<AnalyzeFunnelsAnimation />}
        />
      </DiptychColumn>
    </Section>
  );
}
